module.exports = __webpack_public_path__ + "static/media/festival_02.81c13823.jpg";